import React from 'react';
import SystemInformation from './SystemInformation';
import NetworkInformation from './NetworkInformation';
import StorageInformation from './StorageInformation';
import { SourcePreflightDetails } from './SourcePreflightDetails';
import { Card, Space, Empty, Typography, Skeleton } from '../../../components';

const { Text } = Typography;

const SourceInspection = React.memo(({ source, isFetching, migrate_by_vm, preflightData }) => {
    if (!source) return null;

    if (isFetching) {
        return (
            <Card title="Move Group Information" size="small">
                <Skeleton active />
            </Card>
        );
    }

    // If hostname is empty or null, show waiting for inspection
    if (!source.hostname) {
        return (
            <Card title="Source Inspection" size="small">
                {/* Show preflight details if available */}
                {preflightData && (
                    <SourcePreflightDetails
                        preflightData={preflightData.error ? null : preflightData}
                        isLoading={false}
                        error={preflightData.error}
                    />
                )}
                <Empty description={'Waiting for inspection'} />
            </Card>
        );
    }

    // Use existing source data to render inspection details
    const { attributes } = source;
    if (!attributes) {
        return (
            <Card title="Source Inspection" size="small">
                <Text type="secondary">No inspection data available</Text>
            </Card>
        );
    }

    const { cpu, memory, os, hardware, storage, network } = attributes;
    const isVmMigration = source.collection_type === 'vm';
    const osType = source.os_type || (os?.platform?.toLowerCase()?.includes('windows') ? 'windows' : 'linux');

    return (
        <Card title="Source Inspection" size="small">
            <Space orientation="vertical">
                {/* Show preflight details if available */}
                {preflightData && (
                    <SourcePreflightDetails
                        preflightData={preflightData.error ? null : preflightData}
                        isLoading={false}
                        error={preflightData.error}
                    />
                )}

                <SystemInformation
                    cpu={cpu}
                    memory={memory}
                    hardware={hardware}
                    migrate_by_vm={migrate_by_vm}
                    os={os}
                />

                <NetworkInformation network={network} />

                <StorageInformation storage={storage} isVmMigration={isVmMigration} osType={osType} />
            </Space>
        </Card>
    );
});

export default SourceInspection;
